import { useTranslate } from "@opensea/next-translate"
import React from "react"
import { Modal } from "@/design-system/Modal"
import { MfaMethodsModalBody } from "./components/MfaMethodsModalBody.react"

type Props = {
  onClose: () => void
}

export function MfaMethodsModal({ onClose }: Props) {
  const t = useTranslate("mfa")
  return (
    <>
      <Modal.Header
        onClose={onClose}
        title={t("enrollment.modal.header", "Two-factor verification")}
      />
      <Modal.Body className="flex flex-1 flex-col p-4">
        <MfaMethodsModalBody />
      </Modal.Body>
    </>
  )
}
